import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { MobileUserComponent }   from './user.mobile.component';
import { MobileUsersComponent }  from './users.mobile.component';
import { GoogleSsoModule }       from '../google-sso/google-sso.module';
import { SharedModule }          from '../shared/shared.module';
import { TableModule }           from '../table/table.module';
import { UserComponent }         from './user.component';
import { UsersService }          from './users.service';
import { UserSettingsComponent } from './user.settings.component';
import { UsersComponent }        from './users.component';
import { UsersStates }           from './users.states';

@NgModule({
  declarations: [
    MobileUserComponent,
    MobileUsersComponent,
    UserComponent,
    UserSettingsComponent,
    UsersComponent
  ],
  entryComponents: [
    MobileUserComponent,
    MobileUsersComponent,
    UserComponent,
    UserSettingsComponent,
    UsersComponent
  ],
  imports: [
    GoogleSsoModule,
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: UsersStates })
  ],
  providers: [
    UsersService
  ]
})
export class UsersModule {}
